function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0C3.11929 0 2 1.11929 2 2.5C2 3.88071 3.11929 5 4.5 5C5.88071 5 7 3.88071 7 2.5C7 1.11929 5.88071 0 4.5 0ZM3 2.5C3 1.67157 3.67157 1 4.5 1C5.32843 1 6 1.67157 6 2.5C6 3.32843 5.32843 4 4.5 4C3.67157 4 3 3.32843 3 2.5Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C2.33696 6 1.70107 6.26339 1.23223 6.73223C0.763392 7.20107 0.5 7.83696 0.5 8.5V9.5C0.5 9.77614 0.723858 10 1 10C1.27614 10 1.5 9.77614 1.5 9.5V8.5C1.5 8.10218 1.65804 7.72064 1.93934 7.43934C2.22064 7.15804 2.60218 7 3 7H6C6.39782 7 6.77936 7.15804 7.06066 7.43934C7.34196 7.72064 7.5 8.10217 7.5 8.5V9.5C7.5 9.77614 7.72386 10 8 10C8.27614 10 8.5 9.77614 8.5 9.5V8.5C8.5 7.83696 8.23661 7.20107 7.76777 6.73223C7.29893 6.26339 6.66304 6 6 6H3Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01588 6.44C9.08491 6.17263 9.35763 6.01184 9.625 6.08088C10.1613 6.21936 10.6365 6.53204 10.9759 6.96982C11.3152 7.40761 11.4996 7.94571 11.5 8.49963V9.5C11.5 9.77614 11.2761 10 11 10C10.7239 10 10.5 9.77614 10.5 9.5V8.50037C10.4997 8.16807 10.3891 7.84512 10.1855 7.58249C9.98189 7.31982 9.6968 7.13221 9.375 7.04912C9.10763 6.98009 8.94684 6.70737 9.01588 6.44Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12402 0.0806251C7.85651 0.0121309 7.58412 0.173468 7.51562 0.44098C7.44713 0.708493 7.60847 0.980881 7.87598 1.04938C8.19864 1.13199 8.48462 1.31964 8.68884 1.58274C8.89307 1.84585 9.00392 2.16944 9.00392 2.5025C9.00392 2.83556 8.89307 3.15915 8.68884 3.42226C8.48462 3.68536 8.19864 3.87301 7.87598 3.95563C7.60847 4.02412 7.44713 4.29651 7.51562 4.56402C7.58412 4.83153 7.85651 4.99287 8.12402 4.92438C8.66178 4.78669 9.13842 4.47394 9.47879 4.03543C9.81917 3.59693 10.0039 3.05761 10.0039 2.5025C10.0039 1.94739 9.81917 1.40807 9.47879 0.969569C9.13842 0.531063 8.66178 0.218313 8.12402 0.0806251Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5b776dc5a07227e1643cb23b23fe639d.svg";
export { ForwardRef as ReactComponent };